import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function SettingsPage({ title = "Settings" }) {
    return (
        <Box>
            <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                {title}
            </Typography>
            <Typography color="text.secondary">
                Content for this section can be added here.
            </Typography>
        </Box>
    );
}
